export class ErrorUtil {
    description: string;
    constructor(value: number) {
        this.description = 'server_error_' + value;
    }
}
